import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {SessionService} from '../services/session.service';
import {Roles} from '../enums/enums';
import {DataStore} from "@aws-amplify/datastore";
import {Team, User} from '../../models';

@Component({
    selector: 'app-edit-team',
    templateUrl: './edit-team.page.html',
    styleUrls: ['./edit-team.page.scss'],
})
export class EditTeamPage implements OnInit {
    @Input() teamId: string;

    public currentTeam;
    public emailError = false;
    // public seniorAgents: any[];
    public teamForm: UntypedFormGroup;
    public saveTeamButtonText = "Update";

    constructor(
        public sessionService: SessionService,
        public fb: UntypedFormBuilder,
        public modalController: ModalController,
        public apiService: APIService) {
        this.teamForm = this.fb.group({
            'name': [''],
            'description': [''],
            // 'managerID': [''],
        });
    }

    async ngOnInit() {
        if (!this.teamId) this.saveTeamButtonText = "Create";
        this.currentTeam = this.teamId ? await DataStore.query(Team, this.teamId) : null;
        // this.seniorAgents = await DataStore.query(User, u => u.role("eq", Roles.ADVISOR.displayName)); // we need only seniors for "assignedTo" property

        this.teamForm.setControl('name', new UntypedFormControl(this.currentTeam?.name, Validators.compose([Validators.required, this.nameValidator.bind(this)])));
        this.teamForm.setControl('description', new UntypedFormControl(this.currentTeam?.description));
        // this.teamForm.setControl('managerID', new FormControl(this.currentTeam?.manager?.id));
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    async saveTeam() {
        // this.currentTeam ? await this.updateTeam() : await this.createTeam();
        await this.updateTeam();
        this.modalController.dismiss();
    };

    private async updateTeam() {
        const original = await DataStore.query(Team, this.currentTeam.id);
        // const manager = this.teamForm.value.managerID ? await DataStore.query(User, this.teamForm.value.managerID) : null;
        const manager = await DataStore.query(User, this.currentTeam.manager.id);

        return DataStore.save(Team.copyOf(original, updated => {
            updated.name = this.teamForm.value.name;
            updated.description = this.teamForm.value.description;
            updated.manager = manager;
        }));
    }

    // private createTeam() {
    //     const createTeamInput: Team = new Team({
    //         name: this.teamForm.value.name,
    //         description: this.teamForm.value.description,
    //         manager: this.teamForm.value.managerID

    //     });
        
    //     try {
    //         return DataStore.save(createTeamInput);
    //     } 
    //     catch (e) {
    //         
    //     }
    // }


    // @todo Validation
    isValid(field: string) {
        let formField = this.teamForm.get(field);
        return formField.valid || formField.pristine;
    }

    nameValidator(control: UntypedFormControl): { [s: string]: boolean } {
        if (!!control.value) {
            if (!control.value.match("^[a-zA-Z ,.'-]+$")) {
                return {invalidName: true};
            }
        } else {
            // this.username1 = false;
        }
    }

}
